export type AssetLimitStatus = 'normal' | 'warning' | 'reached';

interface AssetLimitUsage {
  assetsUsed: number;
  assetLimit: number;
  warningThresholdPercent?: number;
}

const isAtWarningThreshold = ({ assetsUsed, assetLimit, warningThresholdPercent }: AssetLimitUsage) =>
  warningThresholdPercent !== undefined && assetsUsed >= Math.floor((warningThresholdPercent / 100) * assetLimit);

export const getAssetLimitStatus = (usage: AssetLimitUsage): AssetLimitStatus => {
  if (usage.assetsUsed >= usage.assetLimit) {
    return 'reached';
  }
  return isAtWarningThreshold(usage) ? 'warning' : 'normal';
};
